// extracted by mini-css-extract-plugin
module.exports = {"BlogSearch":"BlogSearch_BlogSearch__2N097"};